module.exports = __webpack_public_path__ + "media/images/icon__arrow-left-f0298351813fb83007615812ac2a12f5.png";